import React from "react";
import { string } from "prop-types";

const TwitterIcon = ({ color = "#eee" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20.891" height="16.974">
    <g data-name="Group 584">
      <g data-name="Group 583">
        <path
          d="M20.891 2.009a8.929 8.929 0 01-2.468.676A4.259 4.259 0 0020.307.318a8.559 8.559 0 01-2.716 1.037 4.283 4.283 0 00-7.409 2.929 4.41 4.41 0 00.1.977A12.123 12.123 0 011.454.781 4.284 4.284 0 002.771 6.5a4.23 4.23 0 01-1.935-.528v.047a4.3 4.3 0 003.431 4.208 4.274 4.274 0 01-1.123.141 3.787 3.787 0 01-.811-.073 4.324 4.324 0 004 2.984 8.606 8.606 0 01-5.31 1.827A8.023 8.023 0 010 15.052a12.057 12.057 0 006.57 1.922A12.106 12.106 0 0018.76 4.787c0-.189-.007-.372-.016-.554a8.544 8.544 0 002.147-2.224z"
          data-name="Path 15"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

TwitterIcon.propTypes = {
  color: string
};

export default TwitterIcon;
